/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-08 10:53:20
 * @LastEditors: linxi
 * @LastEditTime: 2021-10-18 12:23:30
 */
import {
  ExpandOutlined,
  FullscreenExitOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { unwrapResult } from "@reduxjs/toolkit";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useAnimateNumber from "use-animate-number";
import {
  BasicCharts,
  DataCard,
  DataTag,
  DonutPieCharts,
  LgBasicCharts,
  PieCharts,
  Select,
  Switch,
} from "vscreen/lib/index";
import { selectAppRegionCode } from "../../app/appSlice";
import { AppDispatch } from "../../app/store";
import { Basics } from "../../components/BasicCharts/BasicCharts";
import { DataTable } from "../../components/DataTable/DataTable";
import { FlowchartTag } from "../../components/FlowchartTag/FlowchartTag";
import { Icon } from "../../components/icon/Icons";
import { LineCharts } from "../../components/LineCharts/LineCharts";
import { MapCharts } from "../../components/MapCharts/MapCharts";
import { Progress } from "../../components/Progress/Progress";
import { ProvinceTag } from "../../components/provinceTag/ProvinceTag";
import { TableSimple } from "../../components/TableSimple/DataTable";
import { DateTimeFormat } from "../../models/datetime";
import {
  ErrorDistributionValue,
  getFlagName,
  getStaticName,
  getStaticTitleName,
  getWarningRuleTitleName,
} from "../../models/Province";
import { transformNumber } from "../../models/transformNumber";
import {
  CountyRuleUseProps,
  ErrorDistributionParams,
  StaticDataProps,
} from "../../services/Province";
import { WarningRulesAnaylseParams } from "../../services/WarningRulesAnaylse";
import { useQuery, useWindowSize } from "../../utils/hooks";
import { getIncludeSystemAsync } from "../Factory/FactorySlice";
import { getWarningRuleAnaylseData } from "../WarningRulesAnaylse/WarningRulesAnaylseSilce";
import "./Province.css";
import styles from "./Province.module.css";
import {
  getCityOverview,
  getCountyRuleData,
  getCountyRuleUseData,
  getErrorDistributionData,
  getOrganizationData,
  getProvinceMapAndAnaylseAndLastYaerData,
  getProvinceOverviewData,
  getRegulatoryData,
  getStaticData,
  getWarningRuleData,
} from "./ProvinceSlice";

interface regionType {
  areaName: string[];
  cautionTotal: number;
  doctorTotal: number;
  handleTotal: number;
  medicalTotal: number;
  organizationTotal: number;
  regionCode: string;
  regionLevel: number;
}

// const filterData = [
//   7114, 4707, 5802, 1719, 1496, 2832, 4332, 1805, 719, 3662, 1661,
// ];
const filterData = [
  6741, 4685, 5120, 1721, 1478, 2818, 4573, 1805, 698, 3679, 1671,
];

export const City = () => {
  const history = useHistory();

  const dispatch = useDispatch<AppDispatch>();

  const [FirstDate, setFirstDate] = useState<any>(1);

  const [areaV, setAreaV] = useState(1);

  const [SecondDate, setSecondDate] = useState<ErrorDistributionParams>({
    scope: 2,
    ps: undefined,
  }); // 诊疗行为异常分布请求参数

  const [stiatic, setStatic] = useState<StaticDataProps>({
    type: "ORGANIZATIONTYPE",
  }); // 监管占比

  const [WarningData, setWarningData] = useState<WarningRulesAnaylseParams>({
    dType: 2,
    scope: 2,
    text: "预警占比",
  }); // 预警占比

  const [IsFullscreen, setIsFullscreen] = useState<any>(undefined); // 全屏展示

  const isFullscreen = () => {
    return document.fullscreenElement || false;
  };

  //数字动画配置
  const options = {
    duration: 200,
    enterance: false,
    direct: false,
    disabled: false,
    decimals: 0,
  };

  const [flagOptions, setFlagOptions] = useState([
    "机构类型",
    "监管机构",
    "监管医生",
    "诊疗行为",
  ]);

  const [orgOp, setOrgOp] = useState<any>({ ...options }); //机构数
  const [docOp, setDocOp] = useState<any>({ ...options }); //医生数
  const [medOp, setMedOp] = useState<any>({ ...options }); //诊疗数
  const [errOp, setErrOp] = useState<any>({ ...options }); //预警数
  const [hadOp, setHadOp] = useState<any>({ ...options }); //执法数

  const [area, setArea] = useState("浙江省"); // 地区名

  const [areaData, setAreaData] = useState<any>([]); // 地图数据

  const [Table, setTable] = useState<any>([]); // 监管数据总览

  const [ProgressData, setProgressData] = useState<ErrorDistributionValue[]>(
    []
  ); // 异常行为数据分布

  const [TagData, setTagData] = useState<any>(); // 中心展示数据

  // const [ScrollData, setScrollData] = useState<any>([]);

  const [HandleData, setHandleData] = useState<any>([]); // 折线图诊疗数量

  const [ErrorData, setErrorData] = useState<any>([]); // 折线图预警数

  const [FirstList, setFirstList] = useState<any>([]); // 监管占比饼图

  const [SecondList, setSecondList] = useState<any>([]); // 预警占比饼图

  const [timeData, setTimeData] = useState<any>([]); //处理时间

  const [countyTimeData, setCountTimeData] = useState<any>([]); //县平均处理时间

  const [GroudByList, setGroudByList] = useState<any>([]); // 接入机构占比饼图

  const [ruleUseData, setRuleUseData] = useState<any>([]);

  const code = useSelector(selectAppRegionCode);

  const [ruleUser, setRuleUser] = useState<CountyRuleUseProps>({
    dType: 3,
  });

  const queryString = useQuery();

  const [regionCode, _setRegionCode] = useState(
    queryString.get("regionCode") || code
  );

  const [cityPath, setCityPath] = useState<any>([]);

  useEffect(() => {
    _setRegionCode(queryString.get("regionCode") || code);
  }, [queryString, code]);

  useEffect(() => {
    if (flagOptions) {
      setStatic({
        type: getFlagName(flagOptions[0]),
      });
    }
  }, [flagOptions]);

  // 监管数据总览;
  useEffect(() => {
    if (regionCode) {
      if (areaV === 1) {
        setFlagOptions(["机构类型", "监管机构", "监管医生", "诊疗行为"]);
      } else {
        setFlagOptions(["监管机构", "监管医生", "诊疗行为"]);
      }

      if (areaV !== 3 && regionCode?.length <= 4) {
        dispatch(getProvinceOverviewData({ scope: FirstDate, regionCode }))
          .then(unwrapResult)
          .then((record) => {
            record.pop();
            setTable(record);
          });
      } else if (areaV === 3 && regionCode.length > 4) {
        dispatch(getCityOverview({ scope: FirstDate, regionCode }))
          .then(unwrapResult)
          .then((record) => {
            setTable(record);
          });
      }
    }
  }, [dispatch, FirstDate, regionCode, areaV]);

  // 诊疗行为异常分布;
  useEffect(() => {
    if (regionCode) {
      if (areaV !== 3) {
        dispatch(getErrorDistributionData({ ...SecondDate, regionCode }))
          .then(unwrapResult)
          .then((record) => {
            setProgressData(record);
          });
      } else {
        dispatch(getErrorDistributionData({ ...SecondDate, regionCode, ps: 5 }))
          .then(unwrapResult)
          .then((record) => {
            setProgressData(record);
          });
      }
    }
  }, [dispatch, SecondDate, regionCode]);

  // 地图数据 + 折线图
  useEffect(() => {
    if (regionCode) {
      const key = 10000;
      dispatch(getProvinceMapAndAnaylseAndLastYaerData(regionCode))
        .then(unwrapResult)
        .then((res) => {
          setCityPath(res.cityPathArr);
          setOrgOp({
            ...options,
            decimals: res.userAreaCountData.organizationTotal > key ? 2 : 0,
          });
          setDocOp({
            ...options,
            decimals: res.userAreaCountData.doctorTotal > key ? 2 : 0,
          });
          setMedOp({
            ...options,
            decimals: res.userAreaCountData.medicalTotal > key ? 2 : 0,
          });
          setErrOp({
            ...options,
            decimals: res.userAreaCountData.cautionTotal > key ? 2 : 0,
          });
          setHadOp({
            ...options,
            decimals: res.userAreaCountData.handleTotal > key ? 2 : 0,
          });

          setTagData(res.userAreaCountData);
          setOrganizationValue(
            transformNumber(res.userAreaCountData.organizationTotal)?.value,
            false
          );
          setDoctorValue(
            transformNumber(res.userAreaCountData.doctorTotal)?.value,
            false
          );
          setMedicalRecordValue(
            transformNumber(res.userAreaCountData.medicalTotal)?.value,
            false
          );
          setCautionValue(
            transformNumber(res.userAreaCountData.cautionTotal)?.value,
            false
          );
          setDisposeValue(
            transformNumber(res.userAreaCountData.handleTotal)?.value,
            false
          );
          setHandleData(
            res.latestYearSupervise.map((v) => {
              return v.medicalCountNum;
            })
          );
          setErrorData(
            res.latestYearSupervise.map((v) => {
              return v.cautionNum;
            })
          );
          setAreaData(
            res.subAreaCountData.map((v) => {
              return {
                name: v.areaName,
                ...v,
              };
            })
          );
        });
    }
  }, [dispatch, regionCode]);

  //监管机构占比
  useEffect(() => {
    if (stiatic.type !== "ORGANIZATIONTYPE") {
      dispatch(getStaticData({ ...stiatic, regionCode }))
        .then(unwrapResult)
        .then((res) => {
          setFirstList(
            res.map((v) => {
              return {
                name: v.regionName,
                value: v.total || undefined,
              };
            })
          );
        });
    } else {
      dispatch(getRegulatoryData(regionCode))
        .then(unwrapResult)
        .then((res) => {
          setFirstList(
            res.map((v) => {
              return {
                name: v?.name,
                value: v?.num || undefined,
              };
            })
          );
        });
      // setFirstList([
      //   {
      //     name: "中心卫生院",
      //     // value: Math.floor(TagData?.organizationTotal * 0.01438953488372093),
      //     value: Math.floor(TagData?.organizationTotal * 0.0143895348837209),
      //   },
      //   {
      //     name: "乡镇卫生院",
      //     // value: Math.floor(TagData?.organizationTotal * 0.03075581395348837),
      //     value: Math.floor(TagData?.organizationTotal * 0.0307558139534884),
      //   },
      //   {
      //     name: "社区服务中心",
      //     // value: Math.floor(TagData?.organizationTotal * 0.12319767441860466),
      //     value: Math.floor(TagData?.organizationTotal * 0.123197674418605),
      //   },
      //   {
      //     name: "村卫生室",
      //     // value: Math.floor(TagData?.organizationTotal * 0.32848837209302323),
      //     value: Math.floor(TagData?.organizationTotal * 0.328488372093023),
      //   },
      //   {
      //     name: "诊所",
      //     // value: Math.floor(TagData?.organizationTotal * 0.37372093023255815),
      //     value: Math.floor(TagData?.organizationTotal * 0.373720930232558),
      //   },
      //   {
      //     name: "门诊部",
      //     // value: Math.floor(TagData?.organizationTotal * 0.0702906976744186),
      //     value: Math.floor(TagData?.organizationTotal * 0.0702906976744186),
      //   },
      //   {
      //     name: "综合医院",
      //     // value: Math.floor(TagData?.organizationTotal * 0.041540697674418606),
      //     value: Math.floor(TagData?.organizationTotal * 0.0415406976744186),
      //   },
      //   {
      //     name: "其他",
      //     value:
      //       TagData?.organizationTotal -
      //       Math.floor(TagData?.organizationTotal * 0.0143895348837209) -
      //       Math.floor(TagData?.organizationTotal * 0.0307558139534884) -
      //       Math.floor(TagData?.organizationTotal * 0.123197674418605) -
      //       Math.floor(TagData?.organizationTotal * 0.328488372093023) -
      //       Math.floor(TagData?.organizationTotal * 0.373720930232558) -
      //       Math.floor(TagData?.organizationTotal * 0.0702906976744186) -
      //       Math.floor(TagData?.organizationTotal * 0.0415406976744186),
      //   },
      //   // {
      //   //   name: "省本级医院",
      //   //   value: 18,
      //   // },
      // ])
    }
  }, [dispatch, stiatic, regionCode, TagData]);

  //预警占比
  useEffect(() => {
    if (regionCode) {
      if (areaV === 3 && regionCode.length > 4) {
        dispatch(getCountyRuleData({ regionCode }))
          .then(unwrapResult)
          .then((res) => {
            setCountTimeData(
              res.map((v) => {
                return {
                  name: v.ruleName,
                  value: v.secondsTotal
                    ? parseFloat(
                        String(
                          moment
                            .duration(
                              parseInt(String(v.secondsTotal / v.disposeTotal)),
                              "seconds"
                            )
                            .asHours() / 24 || undefined
                        )
                      ).toFixed(2)
                    : undefined,
                };
              })
            );
          });
        dispatch(getCountyRuleUseData({ ...ruleUser, regionCode }))
          .then(unwrapResult)
          .then((res) => {
            setRuleUseData(
              res.map((v) => {
                return {
                  name: v.provRuleName,
                  value: v.total || undefined,
                };
              })
            );
          });
        dispatch(
          getWarningRuleAnaylseData({ ...WarningData, dType: 2, regionCode })
        )
          .then(unwrapResult)
          .then((res) => {
            setSecondList(
              res.map((v) => {
                return {
                  name: v.provRuleName,
                  value: v.total || undefined,
                };
              })
            );
          });
      } else {
        if (WarningData.text === "预警占比") {
          dispatch(
            getWarningRuleAnaylseData({ ...WarningData, dType: 2, regionCode })
          )
            .then(unwrapResult)
            .then((res) => {
              setSecondList(
                res.map((v) => {
                  return {
                    name: v.provRuleName,
                    value: v.total || undefined,
                  };
                })
              );
            });
        } else {
          dispatch(getWarningRuleData({ ...WarningData, regionCode }))
            .then(unwrapResult)
            .then((res) => {
              setTimeData(
                res.map((v) => {
                  return {
                    name:
                      v.regionName?.endsWith("市") ||
                      v.regionName?.endsWith("县") ||
                      v.regionName?.endsWith("区")
                        ? v.regionName.substring(0, v.regionName.length - 1)
                        : v.regionName?.substring(0, 4),
                    // value1: moment.duration(v.secondsTotal || 0 * 1000).hours(),
                    value1: v.secondsTotal
                      ? parseFloat(
                          String(
                            moment
                              .duration(
                                parseInt(
                                  String(v.secondsTotal / v.disposeTotal)
                                ),
                                "seconds"
                              )
                              .asHours() / 24
                          )
                        ).toFixed(2)
                      : undefined,
                  };
                })
              );
            });
        }
      }
    }
    // }, [dispatch, WarningData, regionCode, areaV, ruleUser]);
  }, [WarningData, areaV, ruleUser, regionCode]);

  // 接入机构占比
  useEffect(() => {
    if (regionCode) {
      if (areaV === 1) {
        dispatch(getOrganizationData({ scope: 2, regionCode }))
          .then(unwrapResult)
          .then((res) => {
            setGroudByList(
              res.map((v, i) => {
                return {
                  name:
                    v.regionName?.endsWith("市") ||
                    v.regionName?.endsWith("县") ||
                    v.regionName?.endsWith("区")
                      ? v.regionName.substring(0, v.regionName.length - 1)
                      : v.regionName?.substr(0, 4),
                  // value1: v.total,
                  value1: ((v.accessTotal / filterData[i]) * 100).toFixed(0),
                  // value2: v.accessTotal,
                };
              })
            );
          });
      } else {
        dispatch(getOrganizationData({ scope: 2, regionCode }))
          .then(unwrapResult)
          .then((res) => {
            setGroudByList(
              res.map((v, i) => {
                return {
                  name:
                    v.regionName?.endsWith("市") ||
                    v.regionName?.endsWith("县") ||
                    v.regionName?.endsWith("区")
                      ? v.regionName.substring(0, v.regionName.length - 1)
                      : v.regionName?.substr(0, 4),
                  // value1: v.total,
                  value1: v.total,
                  value2: v.accessTotal,
                };
              })
            );
          });
      }
    }
  }, [dispatch, regionCode, areaV]);

  useEffect(() => {
    if (cityPath.length >= 1) {
      setArea(cityPath[cityPath.length - 1].cityName);
      setAreaV(cityPath[cityPath.length - 1].regionLevel);
    }
  }, [cityPath]);

  const [organizationValue, setOrganizationValue] = useAnimateNumber(0, orgOp); // 机构数

  const [doctorValue, setDoctorValue] = useAnimateNumber(0, docOp); // 医生数

  const [medicalRecordValue, setMedicalRecordValue] = useAnimateNumber(
    0,
    medOp
  ); // 诊疗数

  const [cautionValue, setCautionValue] = useAnimateNumber(0, errOp); // 预警数

  const [disposeValue, setDisposeValue] = useAnimateNumber(0, hadOp); // 执法数

  //全屏缩放
  useEffect(() => {
    const element: any = document.documentElement;
    if (IsFullscreen === true) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        // 兼容火狐
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        // 兼容谷歌
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        // 兼容IE
        element.msRequestFullscreen();
      }
    } else if (IsFullscreen === false) {
      document.exitFullscreen();
      history.go(0);
      // useForceUpdate()
    }
  }, [IsFullscreen]);
  const [scaledFontSize, setScaledFontSize] = useState(16.0);

  const [windowWidth] = useWindowSize();
  // 配置首页根元素字体大小

  const createStart = () => {
    var stars = document.getElementById("stars");
    // 封装随机数方法
    function randomDistance(max: any, min: any) {
      var distance = Math.floor(Math.random() * (max - min + 1) + min);
      return distance;
    }
    // js随机生成流星
    for (var j = 0; j < 30; j++) {
      var newStar = document.createElement("div");
      newStar.className = "star";
      newStar.style.top = randomDistance(0, -6) + "em";
      newStar.style.left = randomDistance(70, 2) + "em";
      stars?.appendChild(newStar);
    }

    var star: any = document.getElementsByClassName("star");
    // 给流星添加动画延时
    for (var i = 0, len = star.length; i < len; i++) {
      star[i].style.animationDelay = i % 6 === 0 ? "0s" : i * 0.8 + "s";
    }
  };

  useEffect(() => {
    createStart();
  }, []);

  useEffect(() => {
    if (windowWidth > 0) {
      setScaledFontSize((windowWidth / 1920.0) * 16.0);
    }
  }, [windowWidth]);

  const RouterJump = (routerName: string) => {
    history.push(routerName);
  };

  useEffect(() => {
    return () => {
      setSecondDate({
        scope: 2,
        ps: undefined,
      });
      setWarningData({
        text: "预警占比",
        scope: 2,
      });
      setTable([]);
      setFirstDate(1);
      setTable([]);
      setCountTimeData([]);
      setSecondList([]);
      setRuleUseData([]);
      setOrganizationValue(0, true);
      setDoctorValue(0, true);
      setMedicalRecordValue(0, true);
      setCautionValue(0, true);
      setDisposeValue(0, true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regionCode]);

  return (
    <div
      className={styles.bg}
      style={{
        fontSize: scaledFontSize,
        height: document.body.clientHeight + "px",
      }}
    >
      <div id={styles.head}>
        <span>数据更新时间:{moment().format(DateTimeFormat)}</span>
        {/* {areaV === 1 ? (
            <p className={styles.flag}>浙江省诊疗行为智能监管系统</p>
          ) : (
            <p className={styles.noFlag}>诊疗行为智能监管系统</p>
          )} */}
        <p className={styles.flag}>{area}诊疗行为监督在线</p>
        <span>
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setIsFullscreen(!IsFullscreen);
            }}
          >
            {isFullscreen() ? (
              <FullscreenExitOutlined
                style={{
                  fontSize: "1em",
                  marginRight: 4,
                }}
              />
            ) : (
              <ExpandOutlined
                style={{
                  fontSize: "1em",
                  marginRight: 4,
                }}
              />
            )}
            全屏
          </span>
          {areaV !== 1 && areaV !== 2 ? (
            <span
              style={{ marginLeft: "1em", cursor: "pointer" }}
              onClick={() => {
                if (areaV === 2) {
                  history.push(`/#/`);
                  setStatic({
                    type: "ORGANIZATIONTYPE",
                  });
                } else if (areaV === 3) {
                  history.push(`/?regionCode=${regionCode?.substr(0, 4)}#/`);
                  setStatic({
                    type: "ORGANIZATION",
                  });
                }
                setAreaV(areaV - 1);
              }}
            >
              <ArrowLeftOutlined />
              返回
            </span>
          ) : (
            <></>
          )}
          {/* <Link to='/manager' style={{ color: "#fff", marginLeft: "1em" }}>
            进入系统
          </Link> */}
          {/* {regionCode === "3301" ? (
              <span
                style={{ color: "#fff", marginLeft: "1em" }}
                onClick={() => {
                  dispatch(getIncludeSystemAsync(123))
                    .then(unwrapResult)
                    .then((d: any) => {
                      if (
                        typeof d === "string" &&
                        d.toLocaleLowerCase().startsWith("http")
                      ) {
                        window.open(d, "_blank");
                      }
                    });
                }}
              >
                进入个性平台
              </span>
            ) : (
              <></>
            )} */}
        </span>
      </div>
      <div className={styles.content}>
        <div className={styles.left}>
          {areaV !== 3 ? (
            <>
              <DataCard
                quickLink={() => {
                  RouterJump("/statement/pandect");
                }}
                title="监管数据总览"
                extra={
                  <Switch
                    options={["全部", "本年", "本月"]}
                    value={
                      FirstDate === 2
                        ? "本年"
                        : FirstDate === 1
                        ? "本月"
                        : "全部"
                    }
                    onChange={(t) => {
                      if (t === "本年") {
                        setFirstDate(2);
                      } else if (t === "全部") {
                        setFirstDate(null);
                      } else {
                        setFirstDate(1);
                      }
                    }}
                  />
                }
                style={{ flex: 1 }}
              >
                <DataTable
                  data={Table}
                  pagination={areaV === 1 ? false : true}
                ></DataTable>
              </DataCard>
              <DataCard
                quickLink={() => {
                  RouterJump("statement/wraningRuleProportion");
                }}
                title={
                  SecondDate.ps !== 5 ? "诊疗行为异常分布" : "诊疗高发行为分布"
                }
                extra={
                  <>
                    <Switch
                      options={["全部", "本月"]}
                      value={SecondDate.scope ? "本月" : "全部"}
                      onChange={(t) => {
                        if (t === "本月") {
                          setSecondDate({
                            ...SecondDate,
                            scope: 2,
                          });
                        } else {
                          setSecondDate({
                            ...SecondDate,
                            scope: undefined,
                          });
                        }
                      }}
                    />
                    &emsp;
                    <Select
                      prefix={"选择"}
                      options={["违法行为", "高发行为"]}
                      value={SecondDate.ps ? "高发行为" : "违法行为"}
                      onChange={(t) => {
                        if (t === "高发行为") {
                          setSecondDate({
                            ...SecondDate,
                            ps: 5,
                          });
                        } else {
                          setSecondDate({
                            ...SecondDate,
                            ps: undefined,
                          });
                        }
                      }}
                    />
                  </>
                }
                style={{ marginTop: 10 }}
              >
                <div className={styles.list}>
                  {SecondDate.ps === 5 ? (
                    <>
                      {ProgressData?.map((v, i) => {
                        const max = ProgressData?.reduce(
                          (m, d) => m + d.num,
                          0
                        );
                        return (
                          <Progress
                            sortStyle={{
                              color:
                                i === 0
                                  ? "#FF3D00"
                                  : i === 1
                                  ? "#FF8800"
                                  : i === 2
                                  ? "#FFB300"
                                  : "#00DBFE",
                            }}
                            style={{
                              background:
                                i === 0
                                  ? "linear-gradient(90deg, #004CFF 0%, #FF3D00 100%)"
                                  : i === 1
                                  ? "linear-gradient(90deg, #004CFF 0%, #FF9900 100%)"
                                  : i === 2
                                  ? "linear-gradient(90deg, #004CFF 0%, #FFFF00 100%)"
                                  : "linear-gradient(90deg, #004CFF 0%, #00EDFF 100%)",
                            }}
                            key={i}
                            sortNumber={i + 1}
                            name={v.ruleName}
                            value={v.num}
                            max={max}
                          />
                        );
                      })}
                    </>
                  ) : (
                    <div
                      className={
                        Array.from(ProgressData).length > 5 ? styles.rowUp : ""
                      }
                    >
                      {ProgressData?.map((v, i) => {
                        const max = ProgressData?.reduce(
                          (m, d) => m + d.num,
                          0
                        );
                        return (
                          <Progress
                            key={i}
                            sortNumber={i + 1}
                            name={v.ruleName}
                            value={v.num}
                            max={max}
                          />
                        );
                      })}
                      {Array.from(ProgressData).length > 5 ? (
                        <>
                          {ProgressData?.map((v, i) => {
                            const max = ProgressData?.reduce(
                              (m, d) => m + d.num,
                              0
                            );
                            return (
                              <Progress
                                key={i}
                                sortNumber={i + 1}
                                name={v.ruleName}
                                value={v.num}
                                max={max}
                              />
                            );
                          })}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  )}
                </div>
              </DataCard>
            </>
          ) : (
            <>
              <DataCard
                title="诊疗违法行为数据总览"
                extra={
                  <Switch
                    options={["全部", "本月"]}
                    value={FirstDate ? "本月" : "全部"}
                    onChange={(t) => {
                      if (t === "本月") {
                        setFirstDate(2);
                      } else {
                        setFirstDate(null);
                      }
                    }}
                  />
                }
                style={{ flex: 1 }}
              >
                <TableSimple data={Table}></TableSimple>
              </DataCard>
              <DataCard
                title="诊疗高发行为分布"
                extra={
                  <>
                    <Switch
                      options={["全部", "本月"]}
                      value={SecondDate.scope ? "本月" : "全部"}
                      onChange={(t) => {
                        if (t === "本月") {
                          setSecondDate({
                            ...SecondDate,
                            scope: 2,
                          });
                        } else {
                          setSecondDate({
                            ...SecondDate,
                            scope: undefined,
                          });
                        }
                      }}
                    />
                  </>
                }
                style={{ marginTop: 10 }}
              >
                <div className={styles.list}>
                  {ProgressData?.map((v, i) => {
                    const max = ProgressData?.reduce((m, d) => m + d.num, 0);
                    return (
                      <Progress
                        sortStyle={{
                          color:
                            i === 0
                              ? "#FF3D00"
                              : i === 1
                              ? "#FF8800"
                              : i === 2
                              ? "#FFB300"
                              : "#00DBFE",
                        }}
                        style={{
                          background:
                            i === 0
                              ? "linear-gradient(90deg, #004CFF 0%, #FF3D00 100%)"
                              : i === 1
                              ? "linear-gradient(90deg, #004CFF 0%, #FF9900 100%)"
                              : i === 2
                              ? "linear-gradient(90deg, #004CFF 0%, #FFFF00 100%)"
                              : "linear-gradient(90deg, #004CFF 0%, #00EDFF 100%)",
                        }}
                        key={i}
                        sortNumber={i + 1}
                        name={v.ruleName}
                        value={v.num}
                        max={max}
                      />
                    );
                  })}
                </div>
              </DataCard>
            </>
          )}
          {Table.length ? (
            <DataCard
              quickLink={() => {
                RouterJump("/statement/analyse");
              }}
              title="近一年监管变化图"
              style={{ marginTop: 10, marginBottom: 10, flex: 1 }}
            >
              <LineCharts
                handle={HandleData}
                error={ErrorData}
                style={{ height: "calc(100% - 3.5em)" }}
              ></LineCharts>
            </DataCard>
          ) : (
            <></>
          )}
        </div>
        <div className={styles.center}>
          {areaV !== 1 ? (
            <>
              <div className={styles.top}>{area}</div>
              <div className={styles.middle}>
                <div className={styles.tag}>
                  <DataTag
                    Lable="监管医生"
                    text="人"
                    align="right"
                    icon={
                      <Icon
                        icon="doctor"
                        mode="large"
                        style={{ fill: "#fff", width: "3em", marginTop: "1em" }}
                      />
                    }
                    style={{ marginBottom: "1.875em", marginTop: "2.5em" }}
                  >
                    {doctorValue}
                    {transformNumber(TagData?.doctorTotal).unit}
                  </DataTag>
                  <DataTag
                    Lable="监管诊疗行为"
                    text="次"
                    align="right"
                    icon={
                      <Icon
                        icon="behavior"
                        mode="large"
                        style={{ fill: "#fff", width: "3em", marginTop: "1em" }}
                      />
                    }
                  >
                    {medicalRecordValue}
                    {transformNumber(TagData?.medicalTotal).unit}
                  </DataTag>
                </div>
                <div className={styles.zs}>
                  <div className={styles.animationBox}></div>
                  <ul>
                    <p>监管机构</p>
                    <p>
                      <span
                        style={{
                          fontSize: "2em",
                          fontWeight: "bold",
                        }}
                      >
                        {organizationValue}
                        {transformNumber(TagData?.organizationTotal).unit}
                      </span>
                      &nbsp;家
                    </p>
                  </ul>
                </div>
                <div className={styles.tag}>
                  <DataTag
                    Lable="预警数"
                    text="条"
                    icon={
                      <Icon
                        icon="error"
                        mode="large"
                        style={{ fill: "#fff", width: "3em", marginTop: "1em" }}
                      />
                    }
                    style={{ marginBottom: "1.875em", marginTop: "2.5em" }}
                  >
                    {cautionValue}
                    {transformNumber(TagData?.cautionTotal).unit}
                  </DataTag>
                  <DataTag
                    Lable="处置数"
                    text="条"
                    icon={
                      <Icon
                        icon="handle"
                        mode="large"
                        style={{ fill: "#fff", width: "3em", marginTop: "1em" }}
                      />
                    }
                  >
                    {disposeValue}
                    {transformNumber(TagData?.handleTotal).unit}
                  </DataTag>
                </div>
              </div>
            </>
          ) : (
            <div className={styles.flowchart}>
              <div className={styles.chartBg}>
                <p className={styles.medicalTotal}>
                  医疗行为数&nbsp;
                  <span>
                    {medicalRecordValue}
                    {transformNumber(TagData?.medicalTotal).unit}
                  </span>
                  &nbsp;次
                </p>
                <p
                  className={styles.handleTotal}
                  onDoubleClick={() => {
                    RouterJump("/datacenter/FileData");
                  }}
                >
                  处置数据&nbsp;
                  <span>
                    {disposeValue}
                    {transformNumber(TagData?.handleTotal).unit}
                  </span>
                  &nbsp;件
                </p>
                <p className={styles.cautionTotalText}>智能预警</p>

                <div className={styles.cautionTotal}>
                  <span>
                    {cautionValue}
                    {transformNumber(TagData?.cautionTotal).unit}
                  </span>
                  &nbsp;次
                </div>
                <div
                  className={styles.organizationTotal}
                  onDoubleClick={() => {
                    RouterJump("/datacenter/OrganizationListMessage");
                  }}
                >
                  <p>智能监管机构</p>
                  <span>
                    {organizationValue}
                    {transformNumber(TagData?.organizationTotal).unit}
                  </span>
                  &nbsp;家
                </div>
                <div className={styles.doctorTotal}>
                  <p>智能监管医生</p>
                  <span>
                    {doctorValue}
                    {transformNumber(TagData?.doctorTotal).unit}
                  </span>
                  &nbsp;人
                </div>
                <p className={styles.textOne}>AI分析</p>
              </div>
            </div>
          )}
          <div className={styles.bottom} id="stars">
            {/* <div ></div> */}
            <MapCharts
              mapdata={areaData}
              cityCode={Number(regionCode)}
              style={{ height: "95%" }}
              onRecord={(obj: regionType) => {
                if (obj.regionCode === "330100") {
                  dispatch(getIncludeSystemAsync(3301012))
                    .then(unwrapResult)
                    .then((d: any) => {
                      if (
                        typeof d === "string" &&
                        d.toLocaleLowerCase().startsWith("http")
                      ) {
                        window.open(d, "_blank");
                      }
                    });
                } else {
                  if (areaV === 1) {
                    history.push({
                      pathname: "/",
                      search: `?regionCode=${obj.regionCode?.substr(0, 4)}`,
                    });
                  } else if (areaV === 2) {
                    history.push({
                      pathname: "/",
                      search: `?regionCode=${obj.regionCode}`,
                    });
                  }
                }
              }}
            />
          </div>
          {/* {areaV === 1 ? (
              <div className={styles.flagData}>
                <h3 className={styles.flagTitle}>省本级智能监管</h3>
                <ProvinceTag lable='医院数'>
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    18
                  </span>
                  家
                </ProvinceTag>
                <ProvinceTag lable='医生数'>
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    6976
                  </span>
                  人
                </ProvinceTag>
                <ProvinceTag lable='诊疗行为数'>
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    3239.39万
                  </span>
                  次
                </ProvinceTag>
              </div>
            ) : (
              <></>
            )} */}
        </div>
        <div className={styles.right}>
          {areaV !== 3 ? (
            <>
              <DataCard
                quickLink={() => {
                  RouterJump("/statement/pandect");
                }}
                title={getStaticTitleName(stiatic.type || "")}
                style={{ flex: 1, display: "flex", flexDirection: "column" }}
                extra={
                  <>
                    <Select
                      prefix={"选择"}
                      options={flagOptions}
                      value={getStaticName(stiatic.type as string)}
                      onChange={(t) => {
                        if (t === "监管机构") {
                          setStatic({
                            type: "ORGANIZATION",
                          });
                        } else if (t === "监管医生") {
                          setStatic({
                            type: "DOCTOR",
                          });
                        } else if (t === "诊疗行为") {
                          setStatic({
                            type: "MEDICAL",
                          });
                        } else if (t === "机构类型") {
                          setStatic({
                            type: "ORGANIZATIONTYPE",
                          });
                        }
                      }}
                    />
                  </>
                }
              >
                <PieCharts
                  PieData={FirstList}
                  style={{
                    flex: 1,
                    overflow: "hidden",
                    height: "100%",
                    paddingLeft: 16,
                    paddingRight: 16,
                  }}
                />
              </DataCard>
              <DataCard
                quickLink={() => {
                  RouterJump("/statement/wraningRuleProportion");
                }}
                title={getWarningRuleTitleName(WarningData.text as string)}
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 10,
                }}
                extra={
                  <>
                    <Switch
                      options={["全部", "本月"]}
                      value={WarningData.scope ? "本月" : "全部"}
                      onChange={(t) => {
                        if (t === "本月") {
                          setWarningData({
                            ...WarningData,
                            scope: 2,
                          });
                        } else {
                          setWarningData({
                            ...WarningData,
                            scope: undefined,
                          });
                        }
                      }}
                    />
                    &emsp;
                    <Select
                      prefix={"选择"}
                      options={["预警占比", "处理时间"]}
                      value={
                        WarningData.text === "预警占比"
                          ? "预警占比"
                          : "处理时间"
                      }
                      onChange={(t) => {
                        setWarningData({
                          ...WarningData,
                          text: t,
                        });
                      }}
                    />
                  </>
                }
              >
                {WarningData.text === "预警占比" ? (
                  <DonutPieCharts
                    pieData={SecondList}
                    style={{
                      flex: 1,
                      overflow: "hidden",
                      height: "100%",
                      paddingLeft: 16,
                      paddingRight: 16,
                    }}
                  />
                ) : (
                  <LgBasicCharts basicData={timeData} style={{ flex: "1" }} />
                )}
              </DataCard>
              <DataCard
                quickLink={() => {
                  RouterJump("/datacenter/OrganizationListMessage");
                }}
                title="区域机构接入占比"
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 10,
                }}
              >
                {areaV === 1 ? (
                  <Basics basicData={GroudByList} style={{ flex: 1 }} />
                ) : (
                  <BasicCharts
                    basicData={GroudByList}
                    style={{ flex: 1 }}
                  ></BasicCharts>
                )}
              </DataCard>
            </>
          ) : (
            <>
              <DataCard
                title="平均处理时间"
                style={{ flex: 1, display: "flex", flexDirection: "column" }}
              >
                <DonutPieCharts pieData={countyTimeData} style={{ flex: 1 }} />
              </DataCard>
              <DataCard
                title="规则预警占比分析"
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 10,
                }}
                extra={
                  <>
                    <Switch
                      options={["全部", "本月"]}
                      value={WarningData.scope ? "本月" : "全部"}
                      onChange={(t) => {
                        if (t === "本月") {
                          setWarningData({
                            ...WarningData,
                            scope: 2,
                          });
                        } else {
                          setWarningData({
                            ...WarningData,
                            scope: undefined,
                          });
                        }
                      }}
                    />
                  </>
                }
              >
                {/* {SecondList.every((v: any) => v.value) ? ( */}
                <DonutPieCharts
                  pieData={SecondList}
                  style={{
                    flex: 1,
                    overflow: "hidden",
                    height: "100%",
                    paddingLeft: 16,
                    paddingRight: 16,
                  }}
                />
                {/* ) : (
                    <></>
                  )} */}
              </DataCard>
              <DataCard
                // title="规则执法占比分析"
                title="处置占比分析"
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 10,
                }}
                extra={
                  <>
                    <Switch
                      options={["本月", "全部"]}
                      value={ruleUser.scope ? "本月" : "全部"}
                      onChange={(t) => {
                        if (t === "本月") {
                          setRuleUser({
                            ...ruleUser,
                            scope: 2,
                          });
                        } else {
                          setRuleUser({
                            ...ruleUser,
                            scope: undefined,
                          });
                        }
                      }}
                    />
                  </>
                }
              >
                {/* {ruleUseData.every((v: any) => v.value) ? ( */}
                <DonutPieCharts pieData={ruleUseData} style={{ flex: 1 }} />
                {/* ) : (
                    <></>
                  )} */}
              </DataCard>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
